import type { MinMaxConfig } from '../../core/types/min-max-config.js';
import { MinMax } from '../../core/types/min-max.js';
import type { AxisScaleType } from '../../core/types/scales.js';
import { buildScale } from '../../core/utils/core-scale.js';
import type { CategoricalValueScales } from '../types/categorical-bar-chart.js';

const getRange = (size: number, inverted?: boolean) =>
  inverted ? [0, size] : [size, 0];

/**
 * Get Categorical linear scale
 * @param axisBoundaries - min max domain
 * @param maxRange - max range, usually the hight or width of the chart
 * @param inverted - invert ranges
 * @param scale - The different scale the chart can set
 * @param configMinMax - Contains the min and max for the scale if the customer has set it.
 * @returns scaleLinear with correct properties
 */
export function getCategoricalValueScale(
  axisBoundaries: MinMax,
  maxRange: number,
  inverted: boolean = false,
  scale: AxisScaleType = 'linear',
  configMinMax?: Partial<MinMaxConfig>,
): CategoricalValueScales {
  const range = getRange(maxRange, inverted);
  const clamp = false; // needed in case of min or max is specified (see ADES-2528)

  return buildScale(scale, range, axisBoundaries, configMinMax).clamp(clamp);
}
